import { useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import Promo from "../../store/actions/promotion/Index";

const LOOKUP_PARAMS = { page: 1, length: 999 };

const usePromotionFilterOptions = ({ cities = false, jobs = false, stores = false } = {}) => {
  const dispatch = useDispatch();
  const [cityOptions, setCityOptions] = useState([]);
  const [jobOptions, setJobOptions] = useState([]);
  const [storeOptions, setStoreOptions] = useState([]);

  useEffect(() => {
    if (!cities) return undefined;
    let active = true;
    dispatch(Promo.get_city((response) => {
      if (!active) return;
      const options = (response?.data?.data || []).map((item) => ({
        value: item.id,
        label: item.city_name,
      }));
      setCityOptions([{ value: "all", label: "PILIH SEMUA LOKASI" }, ...options]);
    }, LOOKUP_PARAMS));
    return () => { active = false; };
  }, [cities, dispatch]);

  useEffect(() => {
    if (!jobs) return undefined;
    let active = true;
    dispatch(Promo.get_job((response) => {
      if (!active) return;
      const options = (response?.data?.data || []).map((item) => ({
        value: `${item.id}~${item.name}`,
        label: item.name,
      }));
      setJobOptions([
        { value: "all", label: "Pilih Semua Pekerjaan" },
        ...options,
        { value: "other~other", label: "Lainnya" },
      ]);
    }, LOOKUP_PARAMS));
    return () => { active = false; };
  }, [dispatch, jobs]);

  useEffect(() => {
    if (!stores) return undefined;
    let active = true;
    dispatch(Promo.getTypeStore(LOOKUP_PARAMS, (response) => {
      if (!active) return;
      setStoreOptions((response?.data || []).map((item) => ({
        value: item.id,
        label: item.name,
      })));
    }));
    return () => { active = false; };
  }, [dispatch, stores]);

  return { cityOptions, jobOptions, storeOptions };
};

export default usePromotionFilterOptions;
